import React, { useState } from 'react'
import Title from '../../../components/Title/Title';
import { Col, Container, Row } from 'react-bootstrap';
import EventCard from '../../../components/EventCard';
import Button from '../../../components/Button';
import SectionHeader from '../../../components/SectionHeader';
import './TermsAndConditions.scss'


function TermsAndConditions(props) {



    return (
        <>
        
            <div className="container-fluid2 bg2 ">
                <Title options={{ "title": "Terms & Conditions | EFH Education From Home", "description": "Read the terms and conditions for using EFH (Education From Home) online Computer Science courses and tuition services for ICSE and CBSE students.", "image": "", "url": "" }} />

                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <div className="card p-3">
                                <h2 className="text-center fw-bold mb-4" style={{ fontSize: "250%", lineHeight: "2" }}>Terms &<span className="text-primary"> Conditions</span></h2>
                                <div  style={{ fontSize: "110%", lineHeight: "2" , fontStyle:'italic'}}>
                                    <p className="mb-4">These terms and conditions outline the rules and regulations for the use of EFH's website 
and services. </p>
                                    <p> By accessing this website, we assume you accept these terms and conditions in full. Do 
not continue to use EFH's website if you do not accept all of the terms and conditions 
stated on this page. </p>
                                    <h3 className="fw-bold mt-4 mb-3 text-primary">The following terminology applies to these Terms and Conditions:</h3>
                                    <ul style={{ listStyleType: "none", borderBottom: "2px solid black", marginBottom: "50px" }}>
                                        <li className="mb-3">
                                            <span className="fw-bold text-primary">Client</span>: You, the person accessing this website and accepting the Compan
                                        </li>
                                        <li className="mb-3">
                                            <span className="fw-bold text-primary">The Company</span>: EFH Tech Services LLP (Termed as EFH in this document) 
                                        </li>
                                        <li className="mb-3">
                                            <span className="fw-bold text-primary">Service</span>:  The services provided by EFH through its website and application.
                                        </li>
                                    </ul>
                                </div>
                                <ol className="" style={{ fontSize: "130%", lineHeight: "2" }}>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Acceptance of Terms</span>: By accessing or using EFH's website and services, you agree 
to be bound by these terms and conditions. If you do not agree to all the terms and 
conditions, then you may not access the website or use any services. 
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Use of Services</span>: EFH provides digital learning services for CBSE and ICSE students 
of Standard 9-12. By using our services, you agree to use them only for lawful 
purposes and in a manner that does not infringe on the rights of, restrict, or inhibit 
any other user's use of the services. 
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Intellectual Property</span>: All content provided on EFH's website, including but not 
limited to text, graphics, quizzes, assignments, logos, images, videos, and audio 
clips, is the intellectual property of EFH and protected by copyright laws.You may 
not reproduce, distribute, modify, or transmit any content without prior written 
permission from EFH.The syllabus and past papers in the website belongs to ICSE 
and CBSE boards and it is their property. 
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Privacy Policy</span>: EFH respects your privacy and is committed to protecting your 
personal information. Please review our Privacy Policy, which governs how we 
collect, use, and disclose your personal data. 
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Limitation of Liability</span>: EFH shall not be liable for any direct, indirect, incidental, 
special, or consequential damages arising out of or in any way connected with the 
use of its website or services, even if advised of the possibility of such damages. 
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Modifications to Terms and Services</span>: EFH reserves the right to modify or replace 
these terms and conditions at any time without notice. It is your responsibility to 
review these terms periodically for changes. Your continued use of the website and 
services after any modifications indicate your acceptance of the new terms. 

                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Governing Law</span>: These terms and conditions are governed by and construed in 
accordance with the laws of India and you irrevocably submit to the exclusive 
jurisdiction of the courts in India only. 
                                    </li>
                                    <li className="mb-3">
                                   By using EFH's website and services, you agree to abide by these terms and 
conditions. If you have any questions or concerns, please contact us at : <a href="mailto:efhfromhome.prosper.india@gmail.com">efhfromhome.prosper.india@gmail.com</a>.
                                    </li>
                                    <li className="mb-3">
                                  Payment term and Refund policy: Full payment is required at the time of registration 
for any course or program oAered by Education From Home. Once a student has 
enrolled and made the payment, no refunds will be provided under any 
circumstances, including withdrawal, non-attendance, or dissatisfaction with the 
program. In cases where a trial window is oAered, no payment is required to access 
the trial; payment becomes applicable only upon formal registration for the full 
course. The refund and cancellation policy is uniform across all courses and 
programs. All payments must be made through a valid payment method via our 
designated gateway. Education From Home does not store payment information 
and is not responsible for any issues arising from the use of third-party 
payment providers.
                                    </li>
                                </ol>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


export default TermsAndConditions;
